import { render, staticRenderFns } from "./KilosVendidos.vue?vue&type=template&id=54db71dd&"
import script from "./KilosVendidos.vue?vue&type=script&lang=js&"
export * from "./KilosVendidos.vue?vue&type=script&lang=js&"
import style0 from "./KilosVendidos.vue?vue&type=style&index=0&id=54db71dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports